import { WriteDataBuilder } from "./WriteDataBuilder.js";
class WriteOneRelationBuilder {
  constructor(data = void 0) {
    this.data = data;
  }
  static instantiate(data = void 0) {
    return new WriteOneRelationBuilder(data);
  }
  static instantiateFromFactory(builder) {
    if (typeof builder === "function") {
      return builder(WriteOneRelationBuilder.instantiate());
    }
    if (builder && "data" in builder) {
      return WriteOneRelationBuilder.instantiate(builder.data);
    }
    return WriteOneRelationBuilder.instantiate(builder);
  }
  create(data) {
    const resolvedData = WriteDataBuilder.resolveData(data);
    return resolvedData === void 0 ? this : WriteOneRelationBuilder.instantiate({
      create: resolvedData
    });
  }
  connect(where) {
    return WriteOneRelationBuilder.instantiate({ connect: where });
  }
  delete() {
    return WriteOneRelationBuilder.instantiate({ delete: true });
  }
  disconnect() {
    return WriteOneRelationBuilder.instantiate({ disconnect: true });
  }
  update(data) {
    const resolvedData = WriteDataBuilder.resolveData(data);
    return resolvedData === void 0 ? this : new WriteOneRelationBuilder({ update: resolvedData });
  }
  upsert(update, create) {
    const resolvedCreate = WriteDataBuilder.resolveData(create);
    const resolvedUpdate = WriteDataBuilder.resolveData(update);
    return resolvedUpdate === void 0 && resolvedCreate === void 0 ? this : WriteOneRelationBuilder.instantiate({
      upsert: {
        update: resolvedUpdate || {},
        create: resolvedCreate || {}
      }
    });
  }
}
export {
  WriteOneRelationBuilder
};
//# sourceMappingURL=WriteOneRelationBuilder.js.map
